import { useState } from 'react';
import { Box, Group, SegmentedControl, Text, ActionIcon, Tooltip } from '@mantine/core';
import { IconLogout } from '@tabler/icons-react';
import { CountryCtx, SCOPE_LABEL } from './lib/country';
import type { CountryScope } from './lib/api';
import { clearAdminKey } from './lib/api';
import { Logo } from './components/Logo';
import { Dashboard } from './pages/Dashboard';

export function App() {
  const [scope, setScope] = useState<CountryScope>('all');

  return (
    <CountryCtx.Provider value={{ scope, setScope }}>
      <Box mih="100vh" bg="#f5f6f8">
        <Box maw={1280} mx="auto" px={{ base: 'md', sm: 'xl' }} py="lg">
          <Group justify="space-between" align="center" mb="xl" wrap="nowrap">
            <Group gap={10} align="center">
              <Logo size={28} />
              <Text fw={700} c="navy.9" ff='"Source Serif 4", serif' fz="xl">
                ulaim
              </Text>
            </Group>
            <Group gap="sm">
              <SegmentedControl
                value={scope}
                onChange={(v) => setScope(v as CountryScope)}
                data={(['all', 'jordan', 'iraq'] as CountryScope[]).map((s) => ({ value: s, label: SCOPE_LABEL[s] }))}
                radius="xl"
                color="brand"
                size="sm"
                bg="white"
              />
              <Tooltip label="Sign out">
                <ActionIcon
                  variant="subtle"
                  color="gray"
                  size="lg"
                  radius="xl"
                  onClick={() => {
                    clearAdminKey();
                    location.reload();
                  }}
                >
                  <IconLogout size={18} />
                </ActionIcon>
              </Tooltip>
            </Group>
          </Group>
          <Dashboard />
        </Box>
      </Box>
    </CountryCtx.Provider>
  );
}
